import React from 'react'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import { Link } from 'gatsby'
import { IoMdPin } from 'react-icons/io'
import { device } from './Breakpoints'
import { colors } from './Colors'
import imgcentralate from '../icons/centralate.svg'


class CentralAtendimento extends React.Component {
  constructor(props) {
    super()
    this.state = {
      ...props,
    }
  }

  render() {
    const { title, central } = this.state

    const GroupContent = styled.section`
      padding: 2em 0;
      background: ${colors.laranjaGradienteReverso};
      color: #ffffff;
      h2 {
        color: #ffffff;
      }
      @media ${device.mobileL} {
        padding: 2em;
        p,
        h2 {
          text-align: left;
        }
      }

      .inner {
        justify-content: space-between;
        p {
          font-size: 0.8em;
        }
        @media ${device.mobileL} {
          flex-wrap: wrap;
        }
        h2 {
          color: #8e8fc7;
          margin-top: 0;
        }
        .atendimento {
          p {
            display: inline;
            color: #ffffff;
            font-size: 0.8em;
          }
          .tel {
            display: flex;
            text-justify: top;
            p {
              margin: 0 0 0 20px;
              position: relative;
              @media ${device.mobileL} {
                display: block;
              }
              :after {
                content: '';
                border-bottom: 1px solid #f4edc6;
                width: 35px;
                position: absolute;
                bottom: 0px;
                left: 0;
              }
            }
          }
          .central {
            display: flex;
            align-items: center;
            h3 {
              color: #f4edc6;
              font-size: 1.5em;
              @media ${device.mobileL} {
                font-size: 1.3em;
              }
            }
            p {
              display: block;
              margin: 2px;
            }
            div {
              width: 100%;
              @media ${device.mobileL} {
                display: block;
              }
            }
            .info {
              padding-left: 3em;
              @media ${device.mobileL} {
                padding: 0;
              }
              div {
                padding: 20px 0;
                position: relative;
                :last-child {
                  :after {
                    border: none;
                  }
                }
                :after {
                  content: '';
                  border-bottom: 1px solid #f4edc6;
                  width: 35px;
                  position: absolute;
                  bottom: 0px;
                  left: 0;
                }
                h3 {
                  margin: 5px 0;
                }
                a {
                  color: #ffffff;
                }
              }
            }
            @media ${device.mobileL} {
              display: block;
            }
          }
        }
      }
    `
    return (
      <GroupContent>
        <div className="inner center">
          <div className="atendimento">
            <div className="tel">
              <img src={imgcentralate} alt="Telefone" />
              <p>{title}</p>
            </div>
            <div className="central">
              <div className="info">
                <div>
                  <h3>{central}</h3>
                  <a href="tel:(11)5080-6000"> (11) 5080-6000</a>
                </div>
                <div>
                  <p>Horário de agendamento</p>
                  <p>De 2ª a 6ª feira, das 07h às 20h, exceto feriados</p>
                  <p>Sábados, das 08h ás 12h</p>
                </div>
                <div>
                  <p>
                    Para agendamento on-line,
                    {' '}
                    <Link to="/agendamento-de-visitas">clique aqui.</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </GroupContent>
    )
  }
}

export default CentralAtendimento
